import {
  type PortfolioSettlementDto,
  type PortfolioSettlementProjectDto
} from '../../api-schema-types/asset-holdings/AdminPortfolioSettlementDomainDtos'

 
export function portfolioSettlementsApiMapper () {
  const portfoliosMapper = (
    responseData: PortfolioSettlementDto[],
    responseMeta: any,
    responseArgs: any
  ): PortfolioSettlementDto[] => {
    return responseData
  }
  const settlementPortfolioMapper = (
    responseData: PortfolioSettlementDto,
    responseMeta: any,
    responseArgs: any
  ): PortfolioSettlementDto => {
    return responseData
  }
  const settlementPortfolioProjectMapper = (
    responseData: PortfolioSettlementProjectDto,
    responseMeta: any,
    responseArgs: any
  ): PortfolioSettlementProjectDto => {
    return responseData
  }

  return {
    portfoliosMapper, settlementPortfolioMapper, settlementPortfolioProjectMapper
  }
}
